/*
 * File principale dell'applicazione.
 * Definizione delle dipendenze.
 */
define([
	'angular',
	'stacktrace-js',
	'angular-i18n/angular-locale_it-it',
	'angular-route',
	'config',
	'commonControllers',
    'richiestaAccreditamentoControllers',
    'invioAccreditamentoControllers',
    'ristampaAnnullaAccreditamentoControllers',
    'variazioneFigureControllers',
    'pageDirectives',
    'inputDirectives',
    'formDirectives',
    'commonFilters',
    'messageServices',
    'resourceServices',
    'storageServices',
    'ajaxServices',
    'networkServices',
    'resourceServices',
    'codFiscServices',
    'shareParamsServices'
],
function(angular, stacktrace) {
	/*
	 * Best practice
	 */
	'use strict';

	/*
	 * Creazione del nuovo modulo dell'applicazione.
	 * Il nome deve essere lo stesso nome utilizzato nel main.js
	 * Il secondo parametro definisce le dipendenze dei moduli definiti nei file JS.
	 */
	var app = angular.module('registrazione-ente-angular', [
		'ngRoute',
		'configModule',
		'commonControllers',
        'richiestaAccreditamentoControllers',
        'invioAccreditamentoControllers',
        'ristampaAnnullaAccreditamentoControllers',
        'variazioneFigureControllers',
        'pageDirectives',
        'inputDirectives',
        'formDirectives',
        'commonFilters',
        'messageServices',
        'resourceServices',
        'storageServices',
        'ajaxServices',
        'networkServices',
        'resourceServices',
        'codFiscServices',
        'shareParamsServices'
	]);

	app.config(['$routeProvider', '$httpProvider', '$logProvider', 'CONSTANTS',
		function($routeProvider, $httpProvider, $logProvider, CONSTANTS) {

		/*
		 * Abilita/disabilita i log di debug
		 */
		$logProvider.debugEnabled(true);

		var urlArgs = CONSTANTS.URL_ARGS;

		/*
		 * Definizione delle URL, a ogni URL corrispondono una View e un Controller.
		 */
		$routeProvider.
			when('/home', {
				/*
				 * View, partial HTML
				 */
				templateUrl: 'resources/html/partials/homepage.html' + urlArgs
			}).
            when('/richiesta-accreditamento', {
                templateUrl: 'resources/html/partials/richiesta-accreditamento.html' + urlArgs,
				controller: 'RichiestaAccreditamentoCtrl',
				controllerAs: 'vm'
				//resolve: {
    //                data : ['Resolver', 'ResourceService', function(Resolver, ResourceService) {
    //                    return Resolver([ResourceService.fooGet()]);
    //                }]
    //            }
			}).
            when('/invio-richiesta-accreditamento', {
                templateUrl: 'resources/html/partials/invio-richiesta-accreditamento.html' + urlArgs,
                controller: 'InvioRichiestaAccreditamentoCtrl',
                controllerAs: 'vm'
			}).
            when('/ristampa-annulla-accreditamento', {
                templateUrl: 'resources/html/partials/ristampa-annulla-accreditamento.html' + urlArgs,
                controller: 'RistampaAnnullaAccreditamentoCtrl',
                controllerAs: 'vm'
			}).
            when('/variazione-figure', {
                templateUrl: 'resources/html/partials/variazione-figure.html' + urlArgs,
                controller: 'VariazioneFigureCtrl',
                controllerAs: 'vm'
				//resolve: {
    //            	/*
    //        		 * Richiamo il servizio per ottenere tutti gli Smartphone.
    //        		 * Assegno il risultato alla variabile data
    //        		 */
    //                data : ['Resolver', 'ResourceService', function(Resolver, ResourceService) {
    //                    return Resolver([ResourceService.getSmartphones()]);
    //                }]
    //            }
            }).
            when('/404', {
                //nel routing cambio pagina
                templateUrl: 'resources/html/partials/404.html' + urlArgs
            }).
            when('/error', {
                //nel routing cambio pagina
                templateUrl: 'resources/html/partials/error.html' + urlArgs,
                controller: 'ErrorCtrl',
                controllerAs: 'vm'
            }).
			otherwise({
				redirectTo: '/home'
		});

		/*
		 * Iniezione di un Service per la gestione custom delle chiamate HTTP.
		 * Il Service e' definito in network-services.js
		 */
		$httpProvider.interceptors.push('StatusCodeInterceptorService');
	}]);

	/*
	 * Override della gestione delle eccezioni di AngularJS.
	 * In questo modo si possono effettuare elaborazioni aggiuntive al flusso standard.
	 */
	app.config(['$provide', function($provide) {
		$provide.decorator('$exceptionHandler', ['$delegate','$log','$window', function ($delegate, $log, $window) {
			return function(exception, cause) {
				/*
				 * Stampo l'eccezione prima di procedere con il flusso standard
				 */
				try {
					$log.debug("Gestione dell'eccezione");
					var errorMessage = exception.toString();

					stacktrace.fromError(exception, { sourceCache: {} }).then(function(stackframes) {

						var stringifiedStack = stackframes.map(function(sf) {
							return sf.toString();
						}).join('\n');

						$log.error(stringifiedStack);

						/*
						 * Genero l'elemento con gli estremi dell'eccezione da salvare nel SessionStorage
						 */
						var data = angular.toJson({
							errorUrl: $window.location.href,
							errorMessage: errorMessage,
							stackTrace: stringifiedStack
						});

						/*
						 * Scrivo l'eccezione nel SessionStorage del browser
						 */
						$window.sessionStorage.setItem("error_stacktrace", data);
					});
				} catch(loggingError) {
					$log.error("Errore nella gestione dell'eccezione o Internet Explorer");
					$log.error(loggingError);
					/*
					 * In caso di errore o Internet Explorer, scrivo comunque l'eccezione ridotta nel SessionStorage del browser
					 */
					$window.sessionStorage.setItem("error_stacktrace", exception);
				}

				/*
				 * Chiamata all'oggetto standard $exceptionHandler di AngularJS
				 */
				$delegate(exception, cause);
			};
		}]);
	}]);

	/*
	 * Metodo per eseguire funzioni dopo che l'applicazione e' stata lanciata
	 */
	app.run(['$rootScope', 'MessageService', function($rootScope, MessageService) {
		/*
		 * Intercetto l'evento che notifica il cambio di rotta.
		 * L'evento viene emesso da Angular
		 */
		$rootScope.$on("$routeChangeStart", function(event, nextRoute, currentRoute) {
			/*
			 * Richiamo il servizio per cancellare eventuali messaggi a ogni cambio di rotta
			 */
			MessageService.clearMessages();
	    });
	}]);

	return app;
});



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/app.js
// module id = 13
// module chunks = 1